module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "relative"
  }, _vm._l((_vm.result), function(item, index) {
    return _c('div', {
      staticClass: "relative"
    }, [_vm._l((item), function(x) {
      return [_c('div', {
        staticClass: "flex"
      }, [(x.field.label === 'Category') ? _c('h1', {
        staticClass: "title is-4 is-white",
        class: {
          'm-b-15': true
        }
      }, [_vm._v("\n                        " + _vm._s(x.value) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
        class: {
          'toggle': !_vm.expand
        }
      }, [(x.field.label === 'Subcategory') ? _c('h2', {
        staticClass: "title is-5 is-white"
      }, [_c('router-link', {
        attrs: {
          "to": ("/solutions/" + (x.value))
        }
      }, [_c('img', {
        staticClass: "img",
        attrs: {
          "src": "/fstatic/spinner.svg"
        }
      }), _vm._v(" " + _vm._s(x.value) + "\n                        ")])], 1) : _vm._e()])]
    })], 2)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dd3e87c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/solutionsDropdown.vue
// module id = 1143
// module chunks = 1